import parsePhoneNumber from 'libphonenumber-js/mobile';
import { ValidationResult, Validator } from './interfaces';

export const PhoneNumberValidator: Validator = class {
    /**
     * Проверка, является ли значение номером телефона
     */
    static validate(value: string, locale: 'RU' | 'US' | 'FR' = 'RU'): ValidationResult {
        if (!value.startsWith('+') && !value.startsWith('8')) {
            value = '+' + value;
        }
        const phoneNumber = parsePhoneNumber(value, {
            defaultCountry: locale,
            extract: false
        });
        const valid = !!(phoneNumber && phoneNumber.isValid());
        return {
            valid,
            refinedValue: valid ? phoneNumber.number.replace(/[\s()+-]/gi, '') : ''
        };
    }
}